<template>
  <div class="campaign-template">

    <div class="container">
      <div class="campaign-header">
        <h1 class="page-title">สร้างเพจระดมเงินบริจาค</h1>
        <h2 class="sub-title">เพื่อร่วมบริจาคในโอกาสพิเศษของคุณหรือเพื่อนของคุณ</h2>
      </div>
    </div>

    <div class="container pd-0">
      <div class="col-md-push-1 col-md-10 col-lg-push-2 col-lg-8 pd-0">
        <div class="progressbar-wrapper">
          <ul class="progressbar">
            <li class="item active"><span class="step">1 สร้างเพจ</span></li>
            <li class="item"><span class="step">2 เข้าสู่ระบบ</span></li>
            <li class="item"><span class="step">3 บริจาค</span></li>
          </ul>
        </div>
      </div>
    </div>

    <div class="container pd-0">
      <div class="col-md-push-1 col-md-10 col-lg-push-2 col-lg-8 pd-0">
        <div class="_bg-graphic">
          <div class="block shadow">
            <div class="text-center">คุณสามารถสร้างเพจระดมเงินเนื่องในโอกาสพิเศษของคุณหรือของเพื่อนได้ เพื่อส่งต่อความปรารถนาดีและร่วมให้โอกาสทางการศึกษาแก่เด็กด้อยโอกาสไปพร้อมกัน </div>
            <div class="wrapper--pageform ">
              <div class="wrapper-preview-container t-birthday">
                <div class="wrapper-preview" style="transform: scale(1);">
                  <div class="page-card-content" style="background-image: url('/static/img/image-preset-event/02.jpg');">
                    <div class="page-card-type -bottom-up" style="background-image: url('/static/img/image-preset-event/preset-01@2x.jpg');"></div>
                    <div class="page-card-container">
                      <div class="preview-text">
                        <h3 class="page--title">
                          Happy Birthday
                        </h3>
                          <div class="page--owner">
                            <div class="page--owner-name">เฌอปรางค์ อารีย์กุล</div>
                            <div class="page--owner-date">1 มกราคม</div>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
                <div class="form__file">
                  <input type="file" accept="image/*">
                </div>
                <!-- show image after upload -->
                <!-- <img class="img-circle" src="../../../assets/img/profile-mockup.png" alt="people" /> -->

              </div>

              <div class="">
                <label for="ecard-message" class="form__label">ข้อความเชิญชวน</label>
                <textarea class="form__textarea" id="ecard-message"></textarea>
              </div>

              <div class="row">
                <div class="col-sm-4">
                  <label for="ecard-type" class="form__label">เนื่องในวัน</label>
                  <div class="form__select">
                    <select id="ecard-type">
                      <option value="">วันเกิด</option>
                      <option value="">วันครบรอบ</option>
                    </select>
                  </div>
                </div>

                <div class="col-sm-4">
                  <label for="ecard-name" class="form__label">ของ</label>
                  <input type="text" class="form-control form__text" name="title" id="ecard-name" />
                </div>

                <div class="col-sm-4">
                  <label for="ecard-date" class="form__label">วันที่</label>
                  <div class="row">
                    <div class="col-xs-4 col-sm-4 pr-0">
                      <div class="form__select">
                        <select id="ecard-date">
                          <option value="">01</option>
                          <option value="">02</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-xs-8 col-sm-8">
                      <div class="form__select">
                        <select id="ecard-month">
                          <option value="">มกราคม</option>
                          <option value="">กุมภาพันธ์</option>
                          <option value="">มีนาคม</option>
                        </select>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

              <div class="row mt-5">
                <div class="col-sm-4">
                  <div class="">
                    <label for="ecard-target" class="form__label">เป้าหมาย</label>
                    <input type="text" class="form-control form__text" name="title" placeholder="50,000 บาท" id="ecard-target" />
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="">
                    <label for="ecard-deadline" class="form__label">กำหนดวันสิ้นสุดการระดมเงิน</label>
                    <input type="text" class="form-control form__text -pickdate" name="title" placeholder="01/12/2018" id="ecard-deadline" />
                  </div>
                </div>
              </div>


              <div class="mt-30">
                <div class="">
                  <input type="checkbox" name="" id="ecard-check" class="-lg">
                  <label for="ecard-check" class="">ส่งเป็น e-card เพื่อให้ครอบครัวหรือเพื่อนของคุณได้รู้ถึงเรื่องราวดีๆ</label>
                </div>
              </div>
              <div class="row mt-5">
                <div class="col-xs-10 col-sm-8 pr-sm-0">
                  <div class="">
                    <input type="text" class="form-control form__text" name="title" placeholder="อีเมล" id="ecard-mail-01" />
                  </div>
                </div>
                <div class="col-xs-2 col-sm-3">
                  <a href="#" class="-add_plus">เพิ่มอีเมล</a>
                </div>

              </div>
              <div class="text-remark lh1-2">*ระบบจะส่ง e-card ของคุณทันทีที่การบริจาคของคุณสำเร็จ</div>


              <div class="_clearfix mt-15">
                <div class="">
                  <button type="button" class="ma-auto btn btn--default" @click.prevent="submit" :disabled="disabled">ต่อไป ></button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>





  </div>
</template>

<script>
  import DonorInfo from '@/components/DonorInfo'
  import PageSelector from '@/components/PageSelector'
  import ProductCartAction from '@/components/ProductCartAction'
  import ProductDonateChoice from '@/components/ProductDonateChoice'

  export default {
    name: 'ProductDonateTemplate',

    components: {
      DonorInfo,
      PageSelector,
      ProductCartAction,
      ProductDonateChoice
    },

    props: {
      title: { type: String, default: 'บริจาค' },
      product: { type: Object, required: true }
    },

    data () {
      return {
        attributes: {}
      }
    },

    methods: {
      donate () {
        if (!this.$refs.donateChoice.validate()) {
          return
        }

        this.$store.dispatch('clearCart').then(() => {
          this.$refs.cartAction.buyNow()
        })
      }
    }
  }
</script>

<style lang="scss" scoped>

.campaign-template {
  background: rgb(252,186,62) !important; /* Old browsers */
  background: -moz-linear-gradient(top, rgba(252,186,62,1) 0%, rgba(243,137,0,1) 100%) !important; /* FF3.6-15 */
  background: -webkit-linear-gradient(top, rgba(252,186,62,1) 0%,rgba(243,137,0,1) 100%) !important; /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(to bottom, rgba(252,186,62,1) 0%,rgba(243,137,0,1) 100%) !important; /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  color: #fff;
  position: relative;
  padding: 2em 0;
  &:before {
    content: "";
    background: url("../../../assets/img/bg-hex_trans.png") no-repeat top center;
    background-size: 100%;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
  .block {
    background: #fff;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
    background-clip: padding-box;
    color: #1E202D;
  }
}

.campaign-header {
  text-align: center;
  .page-title {
    color: #242424;
    font-size: 2em;
    font-weight: 500;
    line-height: 1.2em;
    margin-bottom: 0.5em;
  }
}

// //* *//
// ._bg-graphic {
//   background: url("../../../assets/img/bg-wave.png") repeat-x top center;
//   padding: 30px;
// }

/*****************
/ Image upload
/*****************/


.wrapper-preview-container {
  position: relative;

  .wrapper-preview {
    width: 670px;
    margin: 1em 0;
    transform-origin: top left;
  }
  .page-card-content {
    background-image: url("/static/img/image-preset-event/01.jpg");
    box-shadow: 0 2px 4px rgba(14, 14, 14, 0.5);
    width: 670px;
    height: 350px;
    overflow: hidden;
    background-repeat: no-repeat;
    background-position: center 200%;
    background-size: cover;
    position: relative;
    word-wrap: normal;

    .page-card-type {
      position: absolute;
      width: 100%;
      height: 100%;
      bottom: 0;
      left: 0;
      &.-bottom-up {
        background: url("/../../static/img/image-preset-event/preset-05@2x.jpg") no-repeat;
        background-size: 100%;
        background-position: center bottom;
        width: 670px;
        height: 180px;
      }
    }

    .page-card-container {
      width: 670px;
      height: 100%;
      margin: 0 auto;
      position: relative;
    }
    .preview-text {
      bottom: 3%;
      left: 0;
      right: 0;
      text-align: center;
      position: absolute;
      color: #242424;

      .page--title {
        font-family: 'Mitr', sans-serif;
        color: #242424;
        font-weight: 500;
        font-size: 2em;
        margin-bottom: 10px;
      }
    }
  }

  // Birthday Type
  &.t-birthday {
    .preview-text {
      color: #fff;
      .page--title {
        color: #fff;
      }
    }
  }

  .form__file {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 115px;
    height: 115px;
    background: url("../../../assets/img/upload-file@2x.png") no-repeat center center;
    background-size: 115px;
    input {
      opacity: 0;
      width: 100%;
      height: 100%;
      cursor: pointer;
     }
  }

  .img-circle {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 125px;
    height: 125px;
    border-radius: 50%;
    border: 5px solid #fff;
    margin-bottom: 1em;
    box-sizing: border-box;
  }

}




</style>



// WEBPACK FOOTER //
// birthday.vue?01952193